import icons from './default.social.icons';
import extractHostname from './extractHostname';

const attachSocialIcons = (items, headerIcons) =>
  items &&
  items.length &&
  items.map((item) => {
    const name = item.name || extractHostname(item.url || item);
    return {
      name: name === 'Twitter' ? 'X' : name,
      url: item.url || item,
      ...(icons(name.toLowerCase(), headerIcons) || icons.default),
    };
  });

export default attachSocialIcons;
